// extracted by mini-css-extract-plugin
export var formContainer = "_kd-0";
export var message = "_kd-1";